import { render } from "./_header.vue?vue&type=template&id=79dfe8a2"
import script from "./_header.vue?vue&type=script&lang=js"
export * from "./_header.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__